import { Link } from "react-router-dom";

export default function CtaBanner() {
  return (
    <section className="mx-auto w-full px-4 py-16 md:px-6 md:py-20" aria-labelledby="cta-title">
      <div className="relative overflow-hidden rounded-lg">
        <img
          src="https://readdy.ai/api/search-image?query=abstract%20warm%20gradient%20background%20of%20coral%20orange%20and%20sunflower%20yellow%20soft%203D%20shapes%20and%20sparkles%2C%20energetic%20playful%20composition%20with%20negative%20space%20on%20the%20left%2C%20cinematic%20lighting%2C%20high%20detail&width=1600&height=700&seq=chigua-cta-banner-01&orientation=landscape"
          alt="513吃瓜 投稿与合作背景图，暖色调抽象图形"
          title="513吃瓜 - 投稿你的二创与表情包"
          className="absolute inset-0 h-full w-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-foreground-950/80 via-foreground-950/60 to-foreground-950/30"></div>

        <div className="relative z-10 px-6 py-16 md:px-12 md:py-20">
          <div className="max-w-xl">
            <h2 id="cta-title" className="font-heading text-3xl leading-snug text-background-50 md:text-5xl">
              你做的梗，值得被更多人看到
            </h2>
            <p className="mt-5 text-sm leading-relaxed text-background-100/85 md:text-base">
              不管是表情包、二创视频还是评论区金句，都欢迎投给我们。被收录的作品会标注创作者昵称，
              并出现在对应的热梗专题里。
            </p>
            <div className="mt-8 flex flex-col gap-3 sm:flex-row">
              <Link
                to="/contact"
                className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-accent-500 px-6 py-3.5 font-label text-sm text-foreground-950 transition-colors hover:bg-accent-400"
              >
                <i className="ri-send-plane-line text-base" aria-hidden="true"></i>
                立即投稿
              </Link>
              <Link
                to="/about"
                className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-100/35 px-6 py-3.5 font-label text-sm text-background-50 transition-colors hover:border-accent-400 hover:text-accent-400"
              >
                了解我们的内容原则
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}